module.exports = __webpack_public_path__ + "img/CHECK.1fca4857.svg";